import { defineComponent as po, watchEffect as xo, ref as j, inject as vo, computed as z, h as f } from "vue";
import { createHoverColor as x, createPressedColor as w } from "./ghl-ui.es899.js";
import { buttonGroupInjectionKey as go } from "./ghl-ui.es900.js";
import { useRtl as Co } from "./ghl-ui.es851.js";
import { isSafari as Bo } from "./ghl-ui.es901.js";
import So from "./ghl-ui.es902.js";
import L from "./ghl-ui.es855.js";
import { warnOnce as Po } from "./ghl-ui.es853.js";
import To from "./ghl-ui.es706.js";
import zo from "./ghl-ui.es870.js";
import wo from "./ghl-ui.es854.js";
import $o from "./ghl-ui.es903.js";
import { createKey as r } from "./ghl-ui.es384.js";
import { changeColor as $ } from "./ghl-ui.es904.js";
import { useThemeClass as Ro } from "./ghl-ui.es857.js";
import { color2Class as Q } from "./ghl-ui.es885.js";
import { resolveWrappedSlot as W, isSlotEmpty as Ho } from "./ghl-ui.es860.js";
import ko from "./ghl-ui.es858.js";
import Eo from "./ghl-ui.es905.js";
import Oo from "./ghl-ui.es906.js";
import Do from "./ghl-ui.es892.js";
import { call as Fo } from "./ghl-ui.es876.js";
const Io = Object.assign(Object.assign({}, L.props), {
  color: String,
  textColor: String,
  text: Boolean,
  block: Boolean,
  loading: Boolean,
  disabled: Boolean,
  circle: Boolean,
  size: String,
  ghost: Boolean,
  round: Boolean,
  secondary: Boolean,
  tertiary: Boolean,
  quaternary: Boolean,
  strong: Boolean,
  focusable: {
    type: Boolean,
    default: !0
  },
  keyboard: {
    type: Boolean,
    default: !0
  },
  tag: {
    type: String,
    default: "button"
  },
  type: {
    type: String,
    default: "default"
  },
  dashed: Boolean,
  renderIcon: Function,
  iconPlacement: {
    type: String,
    default: "left"
  },
  attrType: {
    type: String,
    default: "button"
  },
  bordered: {
    type: Boolean,
    default: !0
  },
  onClick: [Function, Array],
  nativeFocusBehavior: {
    type: Boolean,
    default: !Bo
  }
}), A = po({
  name: "Button",
  props: Io,
  setup(e) {
    process.env.NODE_ENV !== "production" && xo(() => {
      const {
        dashed: t,
        ghost: a,
        text: d,
        secondary: o,
        tertiary: B,
        quaternary: C
      } = e;
      (t || a || d) && (o || B || C) && Po("button", "`dashed`, `ghost` and `text` props can't be used along with `secondary`, `tertiary` and `quaternary` props.");
    });
    const S = j(null), v = j(null), b = j(!1), m = To(() => !e.quaternary && !e.tertiary && !e.secondary && !e.text && (!e.color || e.ghost || e.dashed) && e.bordered), X = vo(go, {}), {
      mergedSizeRef: R
    } = zo({}, {
      defaultSize: "medium",
      mergedSize: (t) => {
        const {
          size: a
        } = e;
        if (a)
          return a;
        const {
          size: d
        } = X;
        if (d)
          return d;
        const {
          mergedSize: o
        } = t || {};
        return o ? o.value : "medium";
      }
    }), H = z(() => e.focusable && !e.disabled), J = (t) => {
      var a;
      H.value || t.preventDefault(), !e.nativeFocusBehavior && (t.preventDefault(), !e.disabled && H.value && ((a = S.value) === null || a === void 0 || a.focus({
        preventScroll: !0
      })));
    }, U = (t) => {
      var a;
      if (!e.disabled && !e.loading) {
        const {
          onClick: d
        } = e;
        d && Fo(d, t), e.text || (a = v.value) === null || a === void 0 || a.play();
      }
    }, Y = (t) => {
      switch (t.key) {
        case "Enter":
          if (!e.keyboard)
            return;
          b.value = !1;
      }
    }, Z = (t) => {
      switch (t.key) {
        case "Enter":
          if (!e.keyboard || e.loading) {
            t.preventDefault();
            return;
          }
          b.value = !0;
      }
    }, oo = () => {
      b.value = !1;
    }, {
      inlineThemeDisabled: G,
      mergedClsPrefixRef: k,
      mergedRtlRef: eo
    } = wo(e), to = L("Button", "-button", So, $o, e, k), ro = Co("Button", eo, k), K = z(() => {
      const t = to.value, {
        common: {
          cubicBezierEaseInOut: a,
          cubicBezierEaseOut: d
        },
        self: o
      } = t, {
        rippleDuration: B,
        opacityDisabled: C,
        fontWeight: E,
        fontWeightStrong: O
      } = o, u = R.value, {
        dashed: D,
        type: y,
        ghost: F,
        text: h,
        color: l,
        round: V,
        circle: I,
        textColor: p,
        secondary: no,
        tertiary: q,
        quaternary: lo,
        strong: io
      } = e, so = {
        "font-weight": io ? O : E
      };
      let i = {
        "--n-color": "initial",
        "--n-color-hover": "initial",
        "--n-color-pressed": "initial",
        "--n-color-focus": "initial",
        "--n-color-disabled": "initial",
        "--n-ripple-color": "initial",
        "--n-text-color": "initial",
        "--n-text-color-hover": "initial",
        "--n-text-color-pressed": "initial",
        "--n-text-color-focus": "initial",
        "--n-text-color-disabled": "initial"
      };
      const P = y === "tertiary", M = y === "default", n = P ? "default" : y;
      if (h) {
        const s = p || l;
        i = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": "#0000",
          "--n-text-color": s || o[r("textColorText", n)],
          "--n-text-color-hover": s ? x(s) : o[r("textColorTextHover", n)],
          "--n-text-color-pressed": s ? w(s) : o[r("textColorTextPressed", n)],
          "--n-text-color-focus": s ? x(s) : o[r("textColorTextHover", n)],
          "--n-text-color-disabled": s || o[r("textColorTextDisabled", n)]
        };
      } else if (F || D) {
        const s = p || l;
        i = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": l || o[r("rippleColor", n)],
          "--n-text-color": s || o[r("textColorGhost", n)],
          "--n-text-color-hover": s ? x(s) : o[r("textColorGhostHover", n)],
          "--n-text-color-pressed": s ? w(s) : o[r("textColorGhostPressed", n)],
          "--n-text-color-focus": s ? x(s) : o[r("textColorGhostHover", n)],
          "--n-text-color-disabled": s || o[r("textColorGhostDisabled", n)]
        };
      } else if (no) {
        const s = M ? o.textColor : P ? o.textColorTertiary : o[r("color", n)], c = l || s, T = y !== "default" && y !== "tertiary";
        i = {
          "--n-color": T ? $(c, {
            alpha: Number(o.colorOpacitySecondary)
          }) : o.colorSecondary,
          "--n-color-hover": T ? $(c, {
            alpha: Number(o.colorOpacitySecondaryHover)
          }) : o.colorSecondaryHover,
          "--n-color-pressed": T ? $(c, {
            alpha: Number(o.colorOpacitySecondaryPressed)
          }) : o.colorSecondaryPressed,
          "--n-color-focus": T ? $(c, {
            alpha: Number(o.colorOpacitySecondaryHover)
          }) : o.colorSecondaryHover,
          "--n-color-disabled": o.colorSecondary,
          "--n-ripple-color": "#0000",
          "--n-text-color": c,
          "--n-text-color-hover": c,
          "--n-text-color-pressed": c,
          "--n-text-color-focus": c,
          "--n-text-color-disabled": c
        };
      } else if (q || lo) {
        const s = M ? o.textColor : P ? o.textColorTertiary : o[r("color", n)], c = l || s;
        q ? (i["--n-color"] = o.colorTertiary, i["--n-color-hover"] = o.colorTertiaryHover, i["--n-color-pressed"] = o.colorTertiaryPressed, i["--n-color-focus"] = o.colorSecondaryHover, i["--n-color-disabled"] = o.colorTertiary) : (i["--n-color"] = o.colorQuaternary, i["--n-color-hover"] = o.colorQuaternaryHover, i["--n-color-pressed"] = o.colorQuaternaryPressed, i["--n-color-focus"] = o.colorQuaternaryHover, i["--n-color-disabled"] = o.colorQuaternary), i["--n-ripple-color"] = "#0000", i["--n-text-color"] = c, i["--n-text-color-hover"] = c, i["--n-text-color-pressed"] = c, i["--n-text-color-focus"] = c, i["--n-text-color-disabled"] = c;
      } else
        i = {
          "--n-color": l || o[r("color", n)],
          "--n-color-hover": l ? x(l) : o[r("colorHover", n)],
          "--n-color-pressed": l ? w(l) : o[r("colorPressed", n)],
          "--n-color-focus": l ? x(l) : o[r("colorFocus", n)],
          "--n-color-disabled": l || o[r("colorDisabled", n)],
          "--n-ripple-color": l || o[r("rippleColor", n)],
          "--n-text-color": p || (l ? o.textColorPrimary : P ? o.textColorTertiary : o[r("textColor", n)]),
          "--n-text-color-hover": p || (l ? o.textColorHoverPrimary : o[r("textColorHover", n)]),
          "--n-text-color-pressed": p || (l ? o.textColorPressedPrimary : o[r("textColorPressed", n)]),
          "--n-text-color-focus": p || (l ? o.textColorFocusPrimary : o[r("textColorFocus", n)]),
          "--n-text-color-disabled": p || (l ? o.textColorDisabledPrimary : o[r("textColorDisabled", n)])
        };
      let N = {
        "--n-border": "initial",
        "--n-border-hover": "initial",
        "--n-border-pressed": "initial",
        "--n-border-focus": "initial",
        "--n-border-disabled": "initial"
      };
      h ? N = {
        "--n-border": "none",
        "--n-border-hover": "none",
        "--n-border-pressed": "none",
        "--n-border-focus": "none",
        "--n-border-disabled": "none"
      } : N = {
        "--n-border": o[r("border", n)],
        "--n-border-hover": o[r("borderHover", n)],
        "--n-border-pressed": o[r("borderPressed", n)],
        "--n-border-focus": o[r("borderFocus", n)],
        "--n-border-disabled": o[r("borderDisabled", n)]
      };
      const {
        [r("height", u)]: _,
        [r("fontSize", u)]: ao,
        [r("padding", u)]: co,
        [r("paddingRound", u)]: uo,
        [r("iconSize", u)]: fo,
        [r("borderRadius", u)]: ho,
        [r("iconMargin", u)]: bo,
        waveOpacity: mo
      } = o, yo = {
        "--n-width": I && !h ? _ : "initial",
        "--n-height": h ? "initial" : _,
        "--n-font-size": ao,
        "--n-padding": I || h ? "initial" : V ? uo : co,
        "--n-icon-size": fo,
        "--n-icon-margin": bo,
        "--n-border-radius": h ? "initial" : I || V ? _ : ho
      };
      return Object.assign(Object.assign(Object.assign(Object.assign({
        "--n-bezier": a,
        "--n-bezier-ease-out": d,
        "--n-ripple-duration": B,
        "--n-opacity-disabled": C,
        "--n-wave-opacity": mo
      }, so), i), N), yo);
    }), g = G ? Ro("button", z(() => {
      let t = "";
      const {
        dashed: a,
        type: d,
        ghost: o,
        text: B,
        color: C,
        round: E,
        circle: O,
        textColor: u,
        secondary: D,
        tertiary: y,
        quaternary: F,
        strong: h
      } = e;
      a && (t += "a"), o && (t += "b"), B && (t += "c"), E && (t += "d"), O && (t += "e"), D && (t += "f"), y && (t += "g"), F && (t += "h"), h && (t += "i"), C && (t += "j" + Q(C)), u && (t += "k" + Q(u));
      const {
        value: l
      } = R;
      return t += "l" + l[0], t += "m" + d[0], t;
    }), K, e) : void 0;
    return {
      selfElRef: S,
      waveElRef: v,
      mergedClsPrefix: k,
      mergedFocusable: H,
      mergedSize: R,
      showBorder: m,
      enterPressed: b,
      rtlEnabled: ro,
      handleMousedown: J,
      handleKeydown: Z,
      handleBlur: oo,
      handleKeyup: Y,
      handleClick: U,
      customColorCssVars: z(() => {
        const {
          color: t
        } = e;
        if (!t)
          return null;
        const a = x(t);
        return {
          "--n-border-color": t,
          "--n-border-color-hover": a,
          "--n-border-color-pressed": w(t),
          "--n-border-color-focus": a,
          "--n-border-color-disabled": t
        };
      }),
      cssVars: G ? void 0 : K,
      themeClass: g == null ? void 0 : g.themeClass,
      onRender: g == null ? void 0 : g.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: e,
      tag: S,
      onRender: v
    } = this;
    v == null || v();
    const b = W(this.$slots.default, (m) => m && f("span", {
      class: `${e}-button__content`
    }, m));
    return f(S, {
      ref: "selfElRef",
      class: [
        this.themeClass,
        `${e}-button`,
        `${e}-button--${this.type}-type`,
        `${e}-button--${this.mergedSize}-type`,
        this.rtlEnabled && `${e}-button--rtl`,
        this.disabled && `${e}-button--disabled`,
        this.block && `${e}-button--block`,
        this.enterPressed && `${e}-button--pressed`,
        !this.text && this.dashed && `${e}-button--dashed`,
        this.color && `${e}-button--color`,
        this.secondary && `${e}-button--secondary`,
        this.loading && `${e}-button--loading`,
        this.ghost && `${e}-button--ghost`
        // required for button group border collapse
      ],
      tabindex: this.mergedFocusable ? 0 : -1,
      type: this.attrType,
      style: this.cssVars,
      disabled: this.disabled,
      onClick: this.handleClick,
      onBlur: this.handleBlur,
      onMousedown: this.handleMousedown,
      onKeyup: this.handleKeyup,
      onKeydown: this.handleKeydown
    }, this.iconPlacement === "right" && b, f(ko, {
      width: !0
    }, {
      default: () => W(this.$slots.icon, (m) => (this.loading || this.renderIcon || m) && f("span", {
        class: `${e}-button__icon`,
        style: {
          margin: Ho(this.$slots.default) ? "0" : ""
        }
      }, f(Eo, null, {
        default: () => this.loading ? f(Oo, {
          clsPrefix: e,
          key: "loading",
          class: `${e}-icon-slot`,
          strokeWidth: 20
        }) : f("div", {
          key: "icon",
          class: `${e}-icon-slot`,
          role: "none"
        }, this.renderIcon ? this.renderIcon() : m)
      })))
    }), this.iconPlacement === "left" && b, this.text ? null : f(Do, {
      ref: "waveElRef",
      clsPrefix: e
    }), this.showBorder ? f("div", {
      "aria-hidden": !0,
      class: `${e}-button__border`,
      style: this.customColorCssVars
    }) : null, this.showBorder ? f("div", {
      "aria-hidden": !0,
      class: `${e}-button__state-border`,
      style: this.customColorCssVars
    }) : null);
  }
}), le = A, ie = A;
export {
  ie as XButton,
  Io as buttonProps,
  le as default
};
